<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="$t( dashboardName )"
        icon="dashboard" v-if="!isRolDisplayUser()"/>
    <!--FILTERS CONTAINER -->
    <v-container >
      <dashboard-filters
          :agents="agentsList"
          :colas="colasList"
          :dates="rangeFixedlist"
          :refresh="refreshList"
          :filtersViews="dashboardFiltersViewList"
          :dashboardId="dashboardId"
          @url-params="setUrlFull"
          @refresh-iframe="refreshDashboard"
      />
    </v-container>

    <!--IFRAME CONTAINER -->
    <v-container fluid class="fill-height" v-if="showIframe">
      <v-row justify="center" align="center">
       <!-- <div :class="`contenedor-responsivo ${desktopView ? 'ghost-layer' : ''}`">
        </div>
        -->
          <iframe
              class="iframe-responsivo"
              ref="grafana"
              :src=urlFull
              :title="$t( dashboardName )"/>
      </v-row>
    </v-container>
    <v-snackbar
        v-model="snackbar"
        fixed
        right
        :timeout="snackbarTimeout"
        :color="snackbarColor"
        class="mt-6"
    >
      <span>{{ snackbarMessage }}</span>
      <v-icon class="ml-2" dark>{{ snackbarIcon }}</v-icon>
      <template v-slot:action="{ attrs }">
        <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="snackbar = false"
        >
          {{ $t("Global.ConfirmDialog.buttonTextClose") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import snackBar from "@/mixins/snackBarMixin";
import loader from "@/mixins/Loader";
import dashboardsApi from "@/mixins/Services/DashboardsApi";
import {mapActions, mapGetters} from "vuex";
import Utils from "@/mixins/Utils";
import DashboardFilters from "@/views/Pages/Dashboards/DashboardFilters";
import Logout from "@/mixins/Logout";
import ROL from "@/config/rol-values";

const REFRESH_LIST_MOCK = ['Off', '5s', '10s', '30s', '1m', '5m', '15m', '30m', '1h', '2h', '1d']

export default {

  name: "DashboardQOS",
  components: {DashboardFilters},
  mixins: [dashboardsApi, snackBar, loader, Utils, Logout],
  data() {
    return {
      dashboardId: null,
      dashboardName: `Global.Main.dashboard${this.$route.meta.id}`,
      showIframe: true,
      url: null,
      dashboardList: null,
      dashboardFiltersViewList: [],
      colasList: [],
      refreshList: REFRESH_LIST_MOCK,
      agentsList:[],
      rol: ROL
    }
  },
  computed: {
    ...mapGetters("scheme", ["dark"]),
    ...mapGetters(["getRoleId", "getUserName", "getUserLastName"]),
    ...mapGetters("navigations", [
      "isVisibleSideNav",
      "isMinSideNav",
      "activeItemStyle",
      "isSidenavPostionRight",
      "isClippedOver",
    ]),
    isDark() {
      return this.$vuetify.theme.dark
    },
    urlFull() {
      const theme = `&theme=${this.isDark ? 'dark' : 'light'}`
      return this.url ? this.url + `${theme}&kiosk&var-reason=${this.getUserName}%20${this.getUserLastName}` : null
    },
    rangeFixedlist() {
      return this.$t('Global.DashboardBase.date-fixed-range-list')
    },
    desktopView(){
      return this.$vuetify.breakpoint.mdAndUp
    }
  },
  watch: {
    '$route.meta.id'(id) {
      this.dashboardId = id
      this.dashboardName = `Global.Main.dashboard${id}`
      this.loadUrl()
    },
    deep: true,
    immediate: true
  },
  methods: {
    ...mapActions("navigations", ["setSidenavVisibility", "setHeaderVisibility" ]),
    async getDashboardData() {
      try {
        this.setLoader(true)
        const data = await this.getDashboard()
        this.dashboardList = data.dashboards
        this.agentsList = data.agents
        this.colasList = data.queues
        this.refreshList = REFRESH_LIST_MOCK
        this.loadUrl()
        this.setLoader(false)
      } catch (e) {
        this.setLoader(false)
        console.error('[DASHBOARD_BASE][submit] getDashboardData:', e.toString())
        if(this.isErrorText(e)){
          const errorCode = this.getErrorText(e);
          this.$emit('launch-snackbar', this.$t(`Global.Error.c${errorCode}`), 'error', "4000", 'mdi-alert-octagon')
        }
      }
    },
    loadUrl() {
      this.url = this.dashboardList?.find((i) => i.dashboardId.includes(this.$route.meta.id))?.url || ''
      this.dashboardFiltersViewList =  this.dashboardList?.find((i) => i.dashboardId.includes(this.$route.meta.id))?.dashboardSelector || []
    },
    setUrlFull(data){
      this.loadUrl()
      this.url = `${this.url}${data}`
    },
    refreshDashboard() {
      this.showIframe = false
      setTimeout(() => {
        this.showIframe = true
        this.url = `${this.url} `
      }, 500);
    },
    isRolDisplayUser(){
      return [this.rol.DISPLAY_USER].includes(this.getRoleId)
    }
  },
  mounted() {
    this.getDashboardData()
    this.dashboardId = this.$route.meta.id
  },
}

</script>

<style>
.contenedor-responsivo {
  overflow: hidden;
  /* padding-top: 56.25%; */
}

.ghost-layer{
  z-index: 2;
  background: transparent;
  position: absolute;
  top: 130px;
  left: 25px;
  width: 94%;
  height: 80vh;
  overflow-x: hidden;
  overflow-y: hidden;
}

.iframe-responsivo {
  position: absolute;
  top: 130px;
  left: 25px;
  width: 97%;
  height: 80vh;
  border: 0;
  overflow-x: hidden;
  overflow-y: hidden;
  z-index: 1;
}

</style>
